import React from 'react';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import { IconButton } from '@mui/material';

const PasteButtonUI = (props) => {
  return (
    <IconButton
      size="small"
      sx={{
        margin: '3px',
        color: 'white',
        padding: '3px',
        backgroundColor: '#7d9eb0',
        '&:hover': {
          backgroundColor: 'grey.400',
        },
      }}
      {...props}
    >
      <ContentPasteIcon fontSize="inherit" />
    </IconButton>
  );
};

export default PasteButtonUI;
